module.exports = __webpack_public_path__ + "img/12.a83ca679.jpg";